import * as React from 'react'
import { BulkActionsProps } from '@user/components/xGrid'
import { DraftLeadBulkActionFooter } from './DraftLeadBulkActionFooter'
import { DraftLeadBulkDelete } from './DraftLeadBulkDelete'

export const DraftLeadBulkActions: React.FC<BulkActionsProps> = (props) => (
  <>
    <DraftLeadBulkDelete {...props} />
    <DraftLeadBulkActionFooter {...props} />
  </>
)
DraftLeadBulkActions.displayName = 'DraftLeadBulkActions'
